<template>
  <el-dialog
    :title="$t('openAdditAcc.selectMt4Tips.title')"
    :visible.sync="value"
    append-to-body
    custom-class="selectMt4TipDialog"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="0"
    center
  >
    <div class="tip-container">{{ $t('openAdditAcc.selectMt4Tips.tipText') }}</div>
    <el-card shadow="never" class="card-container">
      <div slot="header" class="clearfix">
        <div class="title">{{ $t('openAdditAcc.selectMt4Tips.popular') }}</div>
      </div>
      <div class="content-container">
        <div>{{ $t('openAdditAcc.selectMt4Tips.intro') }}</div>
        <ul v-for="i in 3" :key="i" class="content-item">
          {{
            $t(`openAdditAcc.selectMt4Tips.desc${i}`)
          }}
        </ul>
      </div>
    </el-card>
    <span slot="footer" class="dialog-footer">
      <el-button class="el-button blue_button" type="primary" @click="handleChange('mt5')">{{
        $t('openAdditAcc.selectMt4Tips.switchBtn')
      }}</el-button>
      <el-button type="text" @click="handleChange('mt4')">{{ $t('openAdditAcc.selectMt4Tips.continueBtn') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'SelectMt4Tips',
  props: { value: Boolean },
  data() {
    return {};
  },
  methods: {
    handleChange(val) {
      if (val === 'mt5') {
        this.$emit('onOk', val);
      }
      this.$emit('input', false);
    }
  }
};
</script>

<style lang="scss">
.selectMt4TipDialog {
  padding: 40px 70px;
  max-width: 600px !important; // Overwrite element.scss\

  @media (max-width: $DEVICE_SIZE_TABLET) {
    padding: 40px 30px;
  }

  .el-dialog__header {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    text-align: center;
    margin-bottom: 0;
    padding: 0;
  }
  .el-dialog__title {
    font-size: 20px;
    font-weight: 700;
    line-height: 27.24px;
    text-align: center;
    color: $title-color;
  }
  .el-dialog__body {
    text-align: center;
    padding: 0;

    .tip-container {
      font-size: 14px;
      margin: 25px 0 35px;
      font-weight: 400;
      line-height: 19.6px;
      text-align: center;
      color: #1d1d1f;
    }

    .card-container {
      font-size: 14px;
      padding: 16px;
      background-color: #f5f5f566;
      color: #3d3d3d;
      border-color: #cfcfd2;
      border-radius: 12px;
      text-align: start;

      .el-card__header {
        border-color: #cfcfd2;
        .title {
          color: $primary-blue;
          font-weight: 700;
        }
      }

      .el-card__body {
        padding-bottom: 0;
        .content-container {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          gap: 20px;

          ul {
            display: list-item;
            list-style: disc;
            list-style-position: inside;
            text-indent: -18px;
            padding-left: 18px;
          }
        }
      }
    }
  }
  .el-dialog__footer {
    padding: 0;
    margin-top: 35px;
    .dialog-footer {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: center button {
        width: 329px;
        max-width: 100%;
      }
      .el-button + .el-button {
        margin-left: 0px;
        margin-top: 10px;
        border: 0;
        color: $primary-blue;
        text-decoration: underline;
      }
    }
  }
}
</style>
